export default "__VITE_ASSET__CXk733Qb__"